import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import { useQuotes } from 'lib/hooks/queries/billing/useQuotes';
import useModal from 'lib/hooks/useModal';

import { DEFAULT_FILTERS } from 'components/practice/charts/Account/tabs/Quotes/lib/defaultFilters';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { userState } from 'components/state';

import { getBillingItems } from '../lib/getBillingItems';

import PatientPreviewQuote from './components/PatientPreviewQuote';
import { getColDefs } from './lib/configs';

const PatientQuotes = () => {
  const [quote, setQuote] = useState({});
  const user = useRecoilValue(userState);
  const patientId = user?.id;
  const { isOpen, openModal, closeModal } = useModal();

  const cols = getColDefs();
  const onRowClicked = (event) => {
    if (event.colDef?.field === 'actions') return;

    setQuote(event?.data);

    openModal();
  };
  return (
    <>
      <AgTablePage
        noTitle
        noNewButton
        name="patient-quotes"
        queryKey="quotes"
        title="Quotes"
        defaultColumns={cols}
        defaultFilters={DEFAULT_FILTERS}
        useData={useQuotes}
        queryParams={{ patientId }}
        rowStyle={{ cursor: 'pointer' }}
        switchItems={getBillingItems}
        onCellClicked={(event) => onRowClicked(event)}
      />
      {quote?.id && (
        <PatientPreviewQuote
          isOpen={isOpen}
          handleClose={closeModal}
          quote={quote}
          patient={user}
        />
      )}
    </>
  );
};

export default PatientQuotes;
